import { useNavigate, useParams } from "react-router-dom";
import { CountDetail } from "../features/warehouse/CountDetail";

// شاشة كاملة بلا إطار: CountDetail يوفّر الترويسة الثابتة وزر X.
export default function WarehouseCountDetailPage() {
  const { cid } = useParams();
  const navigate = useNavigate();
  const back = () => navigate("/warehouse?tab=counts");
  return <CountDetail countId={cid} onBack={back} />;
}
